<template>
  <div>
    <header class="banner" :style="{background: 'url('+bgImg+') no-repeat'}">
      <h1>{{ title }}</h1>
      <p>{{ tips }}</p>
      <button class="contantUS" @click="ContactPopup">联系我们</button>
    </header>
      <ContactUs
      :dialogVisible="dialogVisible"
      @changeShow="showAddOrUpdate"
      ref="ContactUs">
    </ContactUs>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    },
    bgImg: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showAddOrUpdate (data) {
      if (data === 'false') {
        this.dialogVisible = false
      } else {
        this.dialogVisible = true
      }
    },
    ContactPopup () {
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
.banner{
  width: 100%;
  height: 500px;
  /* background: url('./static/image/ProductSolutions/banner2.png') no-repeat; */
  text-align: left;
  background-size: 100% 100% !important;
  color: #fff;
}
.banner h1{
  padding-top: 120px;
  margin-left: 299px;
  font-size: 48px;
  font-weight: 900;
  letter-spacing: 0.72px;
}
.banner p{
  width: 782px;
  margin: 24px 0 0 299px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 2px;
  opacity: 0.5;
}
.banner button{
  margin: 85px 0 0 299px;
  width: 128px;
  height: 47px;
  background: #F53131;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductSolutions/Header.vue